const Types = {
    CoverCheckerPortalService: Symbol.for("CoverCheckerPortalService"),
    CoverCheckerPortalServiceConfig: Symbol.for("CoverCheckerPortalServiceConfig"),
};

export { Types };
